<template>
  <PageContentLayoutOnly>
    <div>
      <ListViolationConversations :violationID="parseInt(violationID)" />
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ListViolationConversations from '@/pages/Shared/communications/Global/List'

import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'ViolationConversations',

  components: {
    PageContentLayoutOnly,
    ListViolationConversations
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {},

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { violationConversations: { title: 'Conversations' } }
    }
  }
}
</script>

<style></style>
